import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import Projects from '../components/Projects';
import Achievements from '../components/Achievements';

function HomePage() {
  return (
    <>
      <Hero />
      <AboutUs />
      <Services />
      <WhyChooseUs />
      <Projects />
      <Achievements />
    </>
  );
}

export default HomePage;
